import React from 'react';
import styles from './HowToUse.module.scss';
import { Counter } from '../counter/Counter';

export function HowToUse() {
    return (
        <div className="wrapper">
            <div className="container">
                <div className="how-to-use-wrapper">
                    <div className="how-to-use-content">
                        <img className="circle-background left undragable" alt="Cara pakai Jual" src="./assets/how-to-use1.png" />
                        <div className="how-to-use-highlight right">
                            <h2>Tentukan Produk yang Akan Kamu Jual</h2>
                            <p>Cari produk yang ingin kamu jual dari berbagai kategori.</p>
                        </div>
                    </div>
                </div>
                <div className="how-to-use-wrapper">
                    <div className="how-to-use-content">
                        <img className="circle-background right undragable" alt="Cara pakai Sosial media" src="./assets/how-to-use2.png" />
                        {/* <img className="circle-background" src="./assets/how-to-use3.png" /> */}
                        <div className="how-to-use-highlight left">
                            <h2>Bagikan</h2>
                            <p>Promosikan produk tersebut ke teman atau keluargamu melalui media sosial atau toko online-mu.</p>
                        </div>
                    </div>
                </div>
                <div className="how-to-use-wrapper">
                    <div className="how-to-use-content">
                        <img className="circle-background left undragable" alt="Cara pakai keranjang belanja" src="./assets/how-to-use5.png" />
                        <div className="how-to-use-highlight right">
                            {/* <h2>Pesan</h2>
                            <p>Pilih variasi lalu Tambah ke keranjang.</p> */}
                            <h2>Tentukan Keuntungan</h2>
                            <p>Tentukan harga jual yang kamu inginkan untuk produk tersebut lalu Masukkan ke keranjang.</p>
                        </div>
                    </div>
                </div>
                <div className="how-to-use-wrapper">
                    <div className="how-to-use-content">
                        <img className="circle-background right undragable" alt="Cara pakai Ongkos kirim" src="./assets/how-to-use6.png" />
                        <div className="how-to-use-highlight left">
                        <h2>Isi Alamat</h2>
                            <p>Isi alamat pembelimu dengan lengkap untuk menentukan ongkos kirim. </p>
                            <p>Kamu juga dapat memilih dari alamat yang pernah kamu tambahkan sebelumnya lewat tombol Ambil dari Daftar Alamat.</p>
                        </div>
                    </div>
                </div>
                <div className="how-to-use-wrapper">
                    <div className="how-to-use-content">
                        <img className="circle-background left undragable" alt="Cara pakai Pembeli" src="./assets/how-to-use8.png" />
                        <div className="how-to-use-highlight right">
                        <h2>Pemesanan</h2>
                            <p>
                                Sebelum melakukan pemesanan, pastikan produk yang kamu pesan dan alamat yang tertera telah sesuai.   
                                Pastikan juga kamu memasukkan harga produk sesuai dengan keinginanmu.
                            </p>
                            <p>
                                Jika sudah, tekan tombol Pesan Sekarang untuk mengkonfirmasi pemesanan produk.
                            </p>
                        </div>
                    </div>
                </div>
                
                <div className="how-to-use-wrapper">
                    <div className="how-to-use-content">
                        <img className="circle-background right undragable" alt="Cara pakai Transaksi" src="./assets/how-to-use9.png" />
                        <div className="how-to-use-highlight left">
                            <h2>Pembayaran</h2>
                            <p>
                                Selesaikan pembayaranmu melalui metode pembayaran yang tersedia lalu tekan Pembayaran Selesai. 
                            </p>
                            {/* <p>Riselio akan mengirimkan langsung ke pembeli tanpa menyertakan identitas Riselio.</p> */}
                        </div>
                    </div>
                </div>

                <div className="how-to-use-wrapper">
                    <div className="how-to-use-content">
                        <img className="circle-background left undragable" alt="Cara pakai Aman" src="./assets/how-to-use10.png" />
                        <div className="how-to-use-highlight right">
                            <h2>Pengiriman</h2>
                            <p>Riselio akan mengirimkan langsung ke pembeli tanpa menyertakan identitas Riselio.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
